import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { EmailVerificationDialogService } from './email-verification-dialog.service';

interface IEmailVerificationDialogData {
    email: string;
}

@Component({
    selector: 'upsc-email-verification-dialog',
    templateUrl: './email-verification-dialog.component.html',
    styleUrls: ['./email-verification-dialog.component.scss'],
})
export class EmailVerificationDialogComponent {
    public isSaving = false;
    public errorMessage: string | null = null;

    public constructor(
        private readonly dialogRef: MatDialogRef<EmailVerificationDialogComponent>,
        private readonly dialogService: EmailVerificationDialogService,
        private readonly router: Router,
        @Inject(MAT_DIALOG_DATA) public readonly data: IEmailVerificationDialogData,
    ) {
    }

    public close(): void {
        this.dialogRef.close();
    }

    public updateEmail(): void {
        this.dialogRef.close();
        this.router.navigate(['/user-settings']);
    }

    public confirmEmail(): void {
        if (this.isSaving) {
            return;
        }

        this.isSaving = true;
        this.errorMessage = null;
        this.dialogService.recordConfirmation()
            .pipe(finalize(() => this.isSaving = false))
            .subscribe({
                next: () => {
                    this.dialogService.markConfirmed();
                    this.dialogRef.close();
                },
                error: () => {
                    this.errorMessage = 'Unable to confirm your email. Please try again.';
                },
            });
    }
}